import { Injectable } from '@angular/core';
import { WorkspaceService as WorkspaceDataService } from '@app/shared/store/data-services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { WorkspacesService } from 'app/shared/services';
import { mergeMap, tap } from 'rxjs/operators';
import * as fromActions from './workspace.actions';
@Injectable()
export class WorkspaceEffects {
  uploadImage$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(fromActions.uploadImage),
        mergeMap(({ payload }) => this._workspacesService.uploadWorkspaceImage(payload)),
        tap((workspace) => this._workspaceDataService.updateOneInCache(workspace)),
      );
    },
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private _workspacesService: WorkspacesService,
    private _workspaceDataService: WorkspaceDataService,
  ) {}
}
